export default __webpack_public_path__ + "static/small-business-economy-accomplishment-3c-cd92e693211fd5a8bed87f9ea4b18b7f.webp";